import Icon from '../components/Icon.vue'

Icon.register({
  fire: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M216 23.9c0 103.1 168 125.8 168 296.1 0 105.9-86.1 192-192 192s-192-86.1-192-192c0-58.7 27.8-106.8 54.6-135 15-15.7 41.4-5.2 41.4 16.5v85.5c0 35.2 28 64.5 63.2 64.9 35.7 0.5 64.8-28.4 64.8-64 0-88-176-96.2-52.2-277.2 13.5-19.7 44.2-10.8 44.2 13z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/fire.js
// module id = 1357
// module chunks = 0